import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import * as XLSX from "xlsx";
import {WorkSheet} from "xlsx";
import {FileUpload} from "primeng/fileupload/fileupload";
import {Validation} from '@app/shared/enums/validation.enum';

@Component({
  selector: 'app-excel-file-load',
  templateUrl: './excel-file-load.component.html',
  styleUrls: ['./excel-file-load.component.css']
})
export class ExcelFileLoadComponent implements OnInit {

  Validation: typeof Validation = Validation;

  @Input()
  tooltip: string;

  @Output()
  handleAfterLoad: EventEmitter<WorkSheet> = new EventEmitter();


  @ViewChild('excelUpload') excelUpload: FileUpload;

  constructor() {
  }

  ngOnInit(): void {
  }

  onClickUploadExcel(files: File[]): void {
    const reader: FileReader = new FileReader();
    reader.onload = (e) => {
      let arrayBuffer: any = reader.result;

      // convert data to binary string
      let data = new Uint8Array(arrayBuffer);
      let arr = [];
      for (let i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i]);
      }
      let binaryStr = arr.join("");

      let workbook = XLSX.read(binaryStr, {type: "binary"});
      let first_sheet_name = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[first_sheet_name];
      this.handleAfterLoad.emit(worksheet);
    };
    reader.readAsArrayBuffer(files[0]);
    this.excelUpload.clear();
  }
}
